var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("VerReporte"),
      _vm._v(" "),
      _c(
        "h3",
        [
          _c(
            "v-alert",
            {
              staticClass: "letras_titulo",
              attrs: { value: true, color: "#007DBB" }
            },
            [
              _c("v-icon", [_vm._v("picture_as_pdf")]),
              _vm._v("\n      Planilla general\n    ")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            { staticClass: "secondary" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-container",
                    {
                      staticClass: "p-0",
                      staticStyle: { "min-width": "100%" },
                      attrs: { "grid-list-md": "" }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "text-xs-center" },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.gestiones,
                                      "item-value": "valor",
                                      "item-text": "valor",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      label: "Seleccionar gestión",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.gestion,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "gestion", $$v)
                                      },
                                      expression: "form.gestion"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.meses,
                                      "item-value": "id",
                                      "item-text": "valor",
                                      rules: _vm.$validate(["required"]),
                                      required: "",
                                      label: "Seleccionar mes",
                                      outline: "",
                                      clearable: ""
                                    },
                                    model: {
                                      value: _vm.form.mes,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "mes", $$v)
                                      },
                                      expression: "form.mes"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "#812595",
                                        dark: "",
                                        large: "",
                                        round: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.verReporte(1)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Planilla general (EXCEL)\n                  "
                                      ),
                                      _c("v-icon", [_vm._v("description")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "#812595",
                                        dark: "",
                                        large: "",
                                        round: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.verReporte(2)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Planilla general (PDF)\n                  "
                                      ),
                                      _c("v-icon", [_vm._v("picture_as_pdf")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "rgba( 114, 63, 223,0.7)",
                                        round: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.verReporte(3)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Planilla de refrigerios (EXCEL)\n                  "
                                      ),
                                      _c("v-icon", [_vm._v("description")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "rgba( 114, 63, 223,0.7)",
                                        round: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.verReporte(4)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Planilla de refrigerios (PDF)\n                  "
                                      ),
                                      _c("v-icon", [_vm._v("picture_as_pdf")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "rgba( 179, 3, 110 ,0.7)",
                                        round: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.verReporte(5)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  multas y sanciones F11(EXCEL)\n                  "
                                      ),
                                      _c("v-icon", [_vm._v("description")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "rgba( 179, 3, 110 ,0.7)",
                                        round: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.verReporte(6)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  multas y sanciones F11(PDF)\n                  "
                                      ),
                                      _c("v-icon", [_vm._v("picture_as_pdf")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "rgba( 29, 73, 222 ,0.7)",
                                        round: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.verReporte(7)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  multas y sanciones F10(EXCEL)\n                  "
                                      ),
                                      _c("v-icon", [_vm._v("description")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { md6: "", xs12: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "rgba( 29, 73, 222 ,0.7)",
                                        round: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.verReporte(8)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  multas y sanciones F10(PDF)\n                  "
                                      ),
                                      _c("v-icon", [_vm._v("picture_as_pdf")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2aa98642", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2aa98642","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/asistencia/ReportePlanillasGeneral.vue
// module id = null
// module chunks = 